import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "quiz-question"
}
const _hoisted_2 = { class: "p-3 container" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_timer = _resolveComponent("timer")!
  const _component_quiz_details_section = _resolveComponent("quiz-details-section")!
  const _component_question_section = _resolveComponent("question-section")!
  const _component_answer_section = _resolveComponent("answer-section")!
  const _component_next_button = _resolveComponent("next-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.question)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_timer),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_quiz_details_section, { question: _ctx.question }, null, 8, ["question"]),
            (_openBlock(), _createBlock(_component_question_section, {
              question: _ctx.question,
              key: _ctx.question.uuid
            }, null, 8, ["question"])),
            _createVNode(_component_answer_section, { question: _ctx.question }, null, 8, ["question"]),
            (_openBlock(), _createBlock(_component_next_button, {
              question: _ctx.question,
              key: _ctx.question.uuid
            }, null, 8, ["question"]))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, " No Question Found ")),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
  ], 64))
}